import { useCallback, useEffect, useRef, useState } from "react";
import { useBoardShareLinkCopy } from "../../hooks/useBoardShareLinkCopy";

type Props = {
  boardId: string;
  boardTitle: string;
  open: boolean;
  onClose: () => void;
};

export function CabinetShareDialog({ boardId, boardTitle, open, onClose }: Props) {
  const { copyShareLink, text, label, canCopy, busy } = useBoardShareLinkCopy(boardId, open);
  const dialogRef = useRef<HTMLDialogElement>(null);
  const [planBlocked, setPlanBlocked] = useState<string | null>(null);

  useEffect(() => {
    const el = dialogRef.current;
    if (!el) return;
    if (open && !el.open) el.showModal();
    if (!open && el.open) el.close();
  }, [open]);

  const onCopy = useCallback(async () => {
    setPlanBlocked(null);
    try {
      await copyShareLink();
    } catch (e) {
      const msg = e instanceof Error ? e.message : "Ошибка";
      if (msg.includes("Pro") || msg.includes("plan")) setPlanBlocked(msg);
    }
  }, [copyShareLink]);

  return (
    <dialog
      ref={dialogRef}
      className="wb-modal"
      onClose={onClose}
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div className="wb-modal__box">
        <h2 className="wb-modal__heading">Поделиться доской</h2>
        <p className="wb-modal__hint">
          Ссылка откроет «{boardTitle}» без входа в аккаунт (если тариф позволяет).
        </p>
        {planBlocked ? (
          <p className="wb-cabinet-toast wb-cabinet-toast--err" role="alert">
            {planBlocked}
          </p>
        ) : null}
        {label === "copied" ? (
          <p className="wb-cabinet-toast wb-cabinet-toast--ok" role="status">
            Ссылка скопирована в буфер обмена
          </p>
        ) : null}
        {label === "error" ? (
          <p className="wb-cabinet-toast wb-cabinet-toast--err" role="alert">
            Не удалось скопировать ссылку
          </p>
        ) : null}
        <div className="wb-modal__footer">
          <button type="button" className="wb-modal__btn wb-modal__btn--ghost" onClick={onClose}>
            Закрыть
          </button>
          <button
            type="button"
            className={`wb-modal__btn wb-modal__btn--primary${label === "copied" ? " is-copied" : ""}${label === "error" ? " is-error" : ""}`}
            disabled={!canCopy || busy}
            onClick={() => void onCopy()}
          >
            {text === "Ссылка" ? "Скопировать ссылку" : text}
          </button>
        </div>
        <p className="wb-modal__hint" style={{ marginTop: 12 }}>
          Управление доступом — в настройках доски и папок.
        </p>
      </div>
    </dialog>
  );
}
